const initialState = {
  LogoutStatus: false,
  ProfileUpdate: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
  case "LogoutAction":
    return {
      ...state,
      LogoutStatus: action.payload.LogoutStatus,
    }
  case "ProfileUpdateAction":
    return {
      ...state,
      ProfileUpdate: action.payload.ProfileUpdate,
    };
  default:
    return state;
  }
};

export default Reducer;
